import React, { useEffect, useState } from "react";

// components
import BlogSidebarContent from "./BlogSidebarContent";
import LastPost from "./LastPost";
import SocialMedia from "./SocialMedia";
import BlogTag from "./BlogTag";
import BlogSearch from "./BlogSearch";

// API
import { getData, postData } from "../../services/API";
import { Link } from "react-router-dom";
import Loading from "../shared/Loading";

const BlogSidebar = ({ type, setPosts, setPages }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [random, setRandom] = useState([]);
  const [randomLoaded, setRandomLoaded] = useState(true);

  useEffect(() => {
    postData("/blog/post/random-posts", { type }, true)
      .then((res) => {
        setRandom(res.data);
        setRandomLoaded(false);
      })
      .catch((err) => {
        setRandomLoaded(false);
        // toastErr.current.show({
        //   severity: "error",
        //   summary: "خطا هنگام دریافت اطلاعات از سرور",
        //   detail: "لطفا دوباره صفحه را بارگذاری کنید",
        //   life: 3500,
        // });
      });

    getData("/blog/category/get-categories", { type }, false)
      .then((res) => {
        setCategories(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="blog-sidebar md:w-fit w-full h-auto flex flex-col items-center lg:gap-y-10 gap-y-5">
      <BlogSidebarContent customStyle={"pl-0"} title={"جست و جو"}>
        <BlogSearch setPosts={setPosts} setPages={setPages} />
      </BlogSidebarContent>

      <div className="flex w-full">
        <BlogSidebarContent title={"آخرین پست ها"} overflow={true}>
          {randomLoaded ? (
            <Loading />
          ) : random.length > 0 ? (
            random.map((post) => <LastPost data={post} />)
          ) : (
            <span className="text-gray-200">پستی وجود ندارد !</span>
          )}
        </BlogSidebarContent>
      </div>

      <BlogSidebarContent title={"شبکه های اجتماعی"}>
        <SocialMedia />
      </BlogSidebarContent>

      <BlogSidebarContent wrapperClass={"!max-h-fit"} title={"دسته بندی ها"}>
        {/* {loading ? (
          <Loading />
        ) : categories.length > 0 ? (
          <div className="flex items-center gap-3 flex-wrap">
            {categories.map((cat) => (
              <Link to={`/blog-category/${cat.slug}`} className="flex items-center gap-2">
                <span className="block bg-blue-50 text-blue-600 hover:bg-yellow-700 hover:text-white transition-all duration-300 rounded-lg px-2 py-1 text-sm">
                  {cat.name}
                </span>
              </Link>
            ))}
          </div>
        ) : (
          "دسته بندی وجود ندارد !"
        )} */}

        {loading ? (
          <Loading />
        ) : (
          categories.map(
            (cat, i) =>
              i < 10 && (
                <Link
                  to={
                    type === 1
                      ? `/news-category/${cat.slug}`
                      : `/magazine-category/${cat.slug}`
                  }
                  className="relative overflow-hidden group flex items-center px-4 pr-5 h-12 w-full bg-gray-800 rounded-lg"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="w-4 h-4 absolute -right-[3px] -scale-x-100 fill-yellow-700"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span className="text-gray-200 font-bold group-hover:text-yellow-700 transition-all duration-300">
                    {cat.name}
                  </span>
                </Link>
              )
          )
        )}
      </BlogSidebarContent>
    </div>
  );
};

export default BlogSidebar;
